/**
 * Checks if all the grades are selected
 * @param grades
 * @param length
 * @returns true if all the grades are selected
 */
export function allSelected(graded: number, len: number): boolean {
	return graded === len;
}
